"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDebouncedValue = useDebouncedValue;
var react_1 = require("react");
function useDebouncedValue(value, delayMs) {
    if (delayMs === void 0) { delayMs = 300; }
    var _a = (0, react_1.useState)(value), debouncedValue = _a[0], setDebouncedValue = _a[1];
    (0, react_1.useEffect)(function () {
        var timeoutId = setTimeout(function () { return setDebouncedValue(value); }, delayMs);
        return function () { return clearTimeout(timeoutId); };
    }, [value, delayMs]);
    return debouncedValue;
}
